import axiosInstance from "../AxiosInstance";

export const DeleteUser = (data) => {
    return axiosInstance.post('/auth/delete-user' , data)
}
